module.exports = __webpack_public_path__ + "static/media/error_dino.a6e8ea4e.png";